"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const ImportDataDialog_1 = __importDefault(require("./dialogs/ImportDataDialog"));
const ProfileDialog_1 = __importDefault(require("./dialogs/ProfileDialog"));
const ReportColumnPickerDialog_1 = __importDefault(require("./dialogs/ReportColumnPickerDialog"));
const ReportExportDialog_1 = __importDefault(require("./dialogs/ReportExportDialog"));
const GraphQLPage_1 = __importDefault(require("./pages/GraphQLPage"));
const DashboardExportDialog_1 = __importDefault(require("./dialogs/DashboardExportDialog"));
const SharedRoutes = [
    {
        path: lib_pages_1.default.PROFILE,
        component: ProfileDialog_1.default,
        componentType: 'dialog',
    },
    {
        path: lib_pages_1.default.GRAPHQL,
        component: GraphQLPage_1.default,
        componentType: 'page',
    },
    {
        path: lib_pages_1.default.IMPORT_DATA,
        component: ImportDataDialog_1.default,
        componentType: 'dialog',
    },
    {
        path: lib_pages_1.default.REPORT_EXPORT,
        component: ReportExportDialog_1.default,
        componentType: 'dialog',
    },
    {
        path: lib_pages_1.default.DASHBOARD_EXPORT,
        component: DashboardExportDialog_1.default,
        componentType: 'dialog',
    },
    {
        path: lib_pages_1.default.REPORT_COLUMNS,
        component: ReportColumnPickerDialog_1.default,
        componentType: 'dialog',
    },
];
exports.default = SharedRoutes;
